import React from "react";
import {useSelector} from "react-redux";
import {format} from "date-fns";
import {useTranslation} from "react-i18next";
import {buildStyles} from "connectui/component/buildStyles";
import {useTheme} from "connectui/theme/ThemeProvider";
import ICONS from "connectui/icons/iconMap";

import FlexContainer from "connectui/component/layout/FlexContainer";
import Text from "connectui/component/display/Text";
import Tooltip from "connectui/component/display/Tooltip";
import SvgIcon from "connectui/component/display/SvgIcon";
import Container from "connectui/component/layout/Container";

const channelIcons = {
  airbnb: ICONS["airbnb-circle"],
  email: ICONS["email"],
  SMS: ICONS["phone-card"],
  whatsapp: ICONS["whatsapp-circle"],
  ota_email: ICONS["message-circle-filled"],
};

const useStyles = (theme) =>
  buildStyles({
    item: {
      padding: theme.spacing(3),
      borderRadius: `${theme.radius.lg}px`,
      backgroundColor: theme.colors.white,
      width: "100%",
      boxShadow: theme.shadows.xs,
      cursor: "pointer",
    },
    image: {
      width: "64px",
      height: "64px",
      objectFit: "cover",
      backgroundColor: theme.colors.gray100,
      borderRadius: `${theme.radius.sm}px`,
    },
    iconMore: {
      width: "28px",
      height: "28px",
      cursor: "pointer",
      marginRight: theme.spacing(-2),
      padding: theme.spacing(1),
      color: theme.colors.gray700,
    },
    channelIcon: {
      width: "20px",
      height: "20px",
    },
    iconDisabled: {opacity: 0.3},
  });

const AutoMessageItem = ({message, channels, onClick}) => {
  const {theme} = useTheme();
  const classes = useStyles(theme);
  const {t} = useTranslation();
  const listings = useSelector((state) => state.defaultReducer.house_data_dict);

  const {data, hash, listingId, name} = message;
  const firstMsg = data[0];
  const listingName =
    listings[listingId]?.nickname ?? listings[listingId]?.name;

  return (
    <FlexContainer
      alignItems="center"
      gap={theme.spacing(4)}
      className={classes.item}
      onClick={onClick}
    >
      {/* IMAGE */}
      {listings[listingId]?.picture ? (
        <img
          src={listings[listingId]?.picture}
          alt={listingName}
          className={classes.image}
        />
      ) : (
        <Container className={classes.image} />
      )}

      {/* CONTENT */}
      <FlexContainer
        flexDirection="column"
        justifyContent="center"
        sx={{flex: 1, overflow: "hidden", height: "100%"}}
      >
        <FlexContainer
          alignItems="center"
          gap={theme.spacing(2)}
          sx={{width: "100%"}}
        >
          <Text
            variant="textLG"
            weight="semibold"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {name}
          </Text>
          <FlexContainer
            alignItems="center"
            gap={theme.spacing(2)}
            sx={{flex: 1}}
          >
            {channels[hash].map((channel, index) => (
              <Tooltip
                key={`CHANNEL-${channel.id}-${index}`}
                tooltipContent={
                  channel.disabled ? (
                    <Text variant="textXS" weight="semibold" color="white">
                      {t("automessage-disabled-channel")}
                    </Text>
                  ) : null
                }
                colors={{bg: "gray900", text: "white"}}
                sx={{
                  tooltip: {maxWidth: "230px", textWrap: "wrap"},
                }}
              >
                <SvgIcon
                  component={channelIcons[channel.id]}
                  className={`${classes.channelIcon} ${channel.disabled ? classes.iconDisabled : ""}`}
                />
              </Tooltip>
            ))}
          </FlexContainer>
          {/* IMPLEMENT CONTEXT MENU HERE */}
          {/* <SvgIcon
            component={ICONS["more-vertical"]}
            className={classes.iconMore}
            onClick={() => {
              console.log("clicked");
            }}
          /> */}
        </FlexContainer>
        <FlexContainer sx={{width: "100%"}} gap={theme.spacing(2)}>
          <Text
            variant="textSM"
            color="gray600"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              flex: 1,
            }}
          >
            {firstMsg?.action?.body?.[0]?.value}
          </Text>
          {firstMsg?.send_time && (
            <Text
              as="div"
              variant="textXS"
              weight="medium"
              color="textSecondary"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: theme.spacing(1),
              }}
            >
              <SvgIcon
                component={ICONS["send-scheduled"]}
                sx={{
                  width: "18px",
                  height: "18px",
                  padding: "1px",
                  color: theme.colors.textSecondary,
                }}
              />
              {format(firstMsg.send_time, "MMM d, p")}
            </Text>
          )}
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default AutoMessageItem;
